// This file was automatically generated and should not be edited.

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>};
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {[_ in K]?: never};
export type Incremental<T> =
  | T
  | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {input: string; output: string};
  String: {input: string; output: string};
  Boolean: {input: boolean; output: boolean};
  Int: {input: number; output: number};
  Float: {input: number; output: number};
  /** ActionDispatch::Http::UploadedFile */
  File: {input: unknown; output: unknown};
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: {input: string; output: string};
  /** Represents untyped JSON */
  JSON: {input: unknown; output: unknown};
  /** An ISO 8601-encoded date string with microsecond precision. */
  PreciseDateTime: {input: unknown; output: unknown};
};

/** Autogenerated input type of CreateDeliveryEvent */
export type CreateDeliveryEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the driver assignment the event will be associated with */
  driverAssignmentId: Scalars['ID']['input'];
  eventType: DmDeliveryEventTypes | `${DmDeliveryEventTypes}`;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

/** Allowed values for delivery setup */
export enum DeliverySetup {
  /** The customer declined delivery setup */
  None = 'NONE',
  /** The customer was not prompted for a delivery setup */
  NoResponse = 'NO_RESPONSE',
  /** The customer requested delivery setup */
  Required = 'REQUIRED',
}

/** Autogenerated input type of DestroyDriverSession */
export type DestroyDriverSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The delivery event creation source, whether directly or indirectly. */
export enum DmDeliveryEventSource {
  /** This is the default event source and any events that don't match other sources will be set to this. */
  DeliveryManagement = 'DELIVERY_MANAGEMENT',
  /** The event is directly from or a byproduct of a delivery partner. */
  DeliveryPartner = 'DELIVERY_PARTNER',
  /** The event is directly from or a byproduct of an ezDispatch process. */
  Ezdispatch = 'EZDISPATCH',
  /** The event was created from driver geolocation. */
  Geolocation = 'GEOLOCATION',
  /** The event was created from a 1st Party Delivery API integration. */
  PublicDeliveryApi = 'PUBLIC_DELIVERY_API',
}

/** The event type for any given event */
export enum DmDeliveryEventTypes {
  /** The ezDispatch request has been accepted - either programatically or by a third party delivery partner */
  Accepted = 'accepted',
  /** ezDispatch has cancelled the assignment to a third party delivery partner */
  AssignmentCancelled = 'assignment_cancelled',
  /** ezDispatch has assigned the delivery to a third party delivery partner */
  AssignmentCreated = 'assignment_created',
  /** The delivery has been cancelled completely */
  Cancelled = 'cancelled',
  /** A delivery record has been created in either delivery management or ezDispatch */
  Created = 'created',
  /** A driver has arrived at the dropoff location */
  DriverArrivedAtDropoff = 'driver_arrived_at_dropoff',
  /** A driver has arrived to pickup the food */
  DriverArrivedAtPickup = 'driver_arrived_at_pickup',
  /** A driver has been assigned - either by a catering partner or a third party delivery partner */
  DriverAssigned = 'driver_assigned',
  /** A driver has dropped of the food */
  DriverDroppedOff = 'driver_dropped_off',
  /** A driver is on the way to the customer */
  DriverEnRouteToDropoff = 'driver_en_route_to_dropoff',
  /** A driver is on the way to pickup the food */
  DriverEnRouteToPickup = 'driver_en_route_to_pickup',
  /** A driver has picked the food */
  DriverPickedUp = 'driver_picked_up',
  /** A driver has given feedback after completing a delivery */
  DriverProvidedFeedback = 'driver_provided_feedback',
  /**
   * A driver has reported that they are behind schedule
   * @deprecated This is being deprecated without any alternative. No delivery events have been created with this event type since 2022-02-09.
   */
  DriverReportedLateness = 'driver_reported_lateness',
  /** A gps location has been reported for a driver */
  DriverReportedLocation = 'driver_reported_location',
  /** A driver has been unassigned - either by a catering partner or third party delivery partner */
  DriverUnassigned = 'driver_unassigned',
  /** The delivery was not completed at least two hours after the scheduled event */
  Expired = 'expired',
  /** Some sort of issue has been reported with the delivery. */
  Issue = 'issue',
  /** Delivery related information has changed */
  Modified = 'modified',
  /** The delivery has been rejected by ezDispatch or an assignment has been rejected by a third party delivery partner */
  Rejected = 'rejected',
  /** ezDispatch request was deleted by the caterer. */
  RequestDeletedByCaterer = 'request_deleted_by_caterer',
  /** ezDispatch request was deleted by the customer. */
  RequestDeletedByCustomer = 'request_deleted_by_customer',
  /** ezDispatch request was deleted by the delivery partner. */
  RequestDeletedByDeliveryPartner = 'request_deleted_by_delivery_partner',
}

/** The priority level of an ezDispatch delivery. */
export enum DmDeliveryPriority {
  /** A delivery that needs higher priority. */
  High = 'HIGH',
  /** A normal delivery priority. This is the default. */
  Normal = 'NORMAL',
}

/** Current state - unassigned, assigned, in_progress, completed or expired - based on associated delivery events */
export enum DmDeliveryStatus {
  Assigned = 'assigned',
  Completed = 'completed',
  Expired = 'expired',
  InProgress = 'in_progress',
  Unassigned = 'unassigned',
}

/** The vendor hosting the image. */
export enum DmDriverImageVendor {
  Filestack = 'FILESTACK',
}

/** Driver current SMS opt in status - no opt in decision, opted in, opted out */
export enum DmDriverOptInStatus {
  NoOptInDecision = 'NO_OPT_IN_DECISION',
  OptedIn = 'OPTED_IN',
  OptedOut = 'OPTED_OUT',
}

/** Autogenerated input type of DriverAcceptSmsTerms */
export type DriverAcceptSmsTermsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of DriverAccountSelfDelete */
export type DriverAccountSelfDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Represents the current transition experience for the Driver Mobile App */
export enum DriverAppTransitionState {
  Enforce = 'ENFORCE',
  None = 'NONE',
  Suggest = 'SUGGEST',
}

/** Autogenerated input type of DriverFeedback */
export type DriverFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the driver assignment */
  driverAssignmentId: Scalars['ID']['input'];
  dropoffLocation?: InputMaybe<Scalars['String']['input']>;
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of MagicLinkDriverSessionCreate */
export type MagicLinkDriverSessionCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

/** Autogenerated input type of MagicLinkRequest */
export type MagicLinkRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryId?: InputMaybe<Scalars['ID']['input']>;
  driverAssignmentId?: InputMaybe<Scalars['ID']['input']>;
  phone: Scalars['String']['input'];
  /** The source of where the driver assignment occured */
  source?: InputMaybe<SelfAssignSource | `${SelfAssignSource}`>;
};

/** Autogenerated input type of MaskedPhoneNumber */
export type MaskedPhoneNumberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the driver assignment */
  driverAssignmentId: Scalars['ID']['input'];
};

/** Autogenerated input type of RemoveAssignments */
export type RemoveAssignmentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery to be unassigned */
  deliveryId: Scalars['ID']['input'];
};

/** Autogenerated input type of RequestAccountCreate */
export type RequestAccountCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  deliveryId?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

/** Autogenerated input type of SelfAssignDriver */
export type SelfAssignDriverInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the delivery to be assigned to */
  deliveryId: Scalars['ID']['input'];
  /** Driver provided first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Driver provided last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Origin of the request */
  source?: InputMaybe<SelfAssignSource | `${SelfAssignSource}`>;
};

/** Reasons why a delivery may not be self assignabled */
export enum SelfAssignErrorTypes {
  /** Delivery is already assigned to another driver */
  Assigned = 'assigned',
  /** Delivery is now ezDispatch */
  Ezdispatch = 'ezdispatch',
  /** Delivery is now in a completed/expired/cancelled state */
  Finalized = 'finalized',
  /** Delivery is being handled by Relish */
  Relish = 'relish',
  /** Delivery is now takeout */
  Takeout = 'takeout',
}

/** Sources from where the driver initiated the self assign */
export enum SelfAssignSource {
  /** Via the flash message on Order Details */
  Alert = 'alert',
  /** Via the caterer accept flow */
  CatererAccept = 'caterer_accept',
  /** Via the food prep flow */
  FoodPrep = 'food_prep',
  /** Via the QR Code on the Order PDF */
  Qrcode = 'qrcode',
  /** Via an SMS with a link to sign up */
  Sms = 'sms',
}

/** Allowed values for query sorting */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

/** Range of timestamps */
export type TimeRangeInput = {
  ending: Scalars['ISO8601DateTime']['input'];
  starting: Scalars['ISO8601DateTime']['input'];
};

/** Autogenerated input type of UploadAssignmentImage */
export type UploadAssignmentImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the driver assignment */
  driverAssignmentId: Scalars['ID']['input'];
  image: Scalars['File']['input'];
};

export type CreateDeliveryEventMutationVariables = Exact<{
  input: CreateDeliveryEventInput;
}>;

export type CreateDeliveryEventMutation = {
  createDeliveryEvent?: {
    __typename?: 'CreateDeliveryEventPayload';
    driverAssignment?: {
      __typename?: 'DmDriverAssignment';
      id: string;
      delivery: {__typename?: 'DmDelivery'; id: string; status?: DmDeliveryStatus | null};
    } | null;
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type DriverAccountSelfDeleteMutationVariables = Exact<{
  input: DriverAccountSelfDeleteInput;
}>;

export type DriverAccountSelfDeleteMutation = {
  driverAccountSelfDelete?: {
    __typename?: 'DriverAccountSelfDeletePayload';
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type DeliveryMetadataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeliveryMetadataQuery = {
  deliveryMetadata: {
    __typename?: 'DeliveryMetadata';
    assignable: boolean;
    unassignableReason?: SelfAssignErrorTypes | null;
  };
};

export type DestroyDriverSessionMutationVariables = Exact<{
  input: DestroyDriverSessionInput;
}>;

export type DestroyDriverSessionMutation = {
  destroyDriverSession?: {
    __typename?: 'DestroyDriverSessionPayload';
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type DriverAcceptSmsTermsMutationVariables = Exact<{
  input: DriverAcceptSmsTermsInput;
}>;

export type DriverAcceptSmsTermsMutation = {
  driverAcceptSmsTerms?: {
    __typename?: 'DriverAcceptSmsTermsPayload';
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type DriverAssignmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DriverAssignmentQuery = {
  driverAssignment: {
    __typename?: 'DmDriverAssignment';
    id: string;
    delivery: {
      __typename?: 'DmDelivery';
      id: string;
      orderNumber: string;
      eventAt: string;
      deliverySetup: DeliverySetup;
      distanceInMiles?: number | null;
      durationInMinutes?: number | null;
      driverAskFor?: string | null;
      status?: DmDeliveryStatus | null;
      pickupAddress: {
        __typename?: 'DmAddress';
        id: string;
        instructions?: string | null;
        locationName?: string | null;
        street1?: string | null;
        street2?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
      };
      dropoffAddress: {
        __typename?: 'DmAddress';
        id: string;
        locationName?: string | null;
        street1?: string | null;
        street2?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
        phone?: string | null;
        instructions?: string | null;
      };
      dropoffWindow?: {__typename?: 'DeliveryArrivalWindow'; endAt: string; startAt: string} | null;
      order: {
        __typename?: 'DmOrder';
        orderItems: Array<{__typename?: 'DmOrderItem'; name: string; quantity: number}>;
      };
    };
    feedback?: {__typename?: 'DmDriverFeedback'; message: string} | null;
  };
};

export type DriverAssignmentsQueryVariables = Exact<{
  eventAtRange?: InputMaybe<TimeRangeInput>;
}>;

export type DriverAssignmentsQuery = {
  driverAssignments: Array<{
    __typename?: 'DmDriverAssignment';
    id: string;
    delivery: {
      __typename?: 'DmDelivery';
      id: string;
      eventAt: string;
      orderNumber: string;
      status?: DmDeliveryStatus | null;
      pickupAddress: {__typename?: 'DmAddress'; id: string; timeZoneIdentifier?: string | null};
      dropoffAddress: {
        __typename?: 'DmAddress';
        id: string;
        street1?: string | null;
        street2?: string | null;
        city?: string | null;
        state?: string | null;
        zip?: string | null;
      };
    };
  }>;
};

export type DriverFeedbackMutationVariables = Exact<{
  input: DriverFeedbackInput;
}>;

export type DriverFeedbackMutation = {
  driverFeedback?: {
    __typename?: 'DriverFeedbackPayload';
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type MagicLinkDriverSessionCreateMutationVariables = Exact<{
  input: MagicLinkDriverSessionCreateInput;
}>;

export type MagicLinkDriverSessionCreateMutation = {
  magicLinkDriverSessionCreate?: {
    __typename?: 'MagicLinkDriverSessionCreatePayload';
    success: boolean;
  } | null;
};

export type MaskedPhoneNumberMutationVariables = Exact<{
  input: MaskedPhoneNumberInput;
}>;

export type MaskedPhoneNumberMutation = {
  maskedPhoneNumber?: {
    __typename?: 'MaskedPhoneNumberPayload';
    driverAssignment?: {
      __typename?: 'DmDriverAssignment';
      id: string;
      maskedPhoneNumber?: string | null;
    } | null;
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type MeQueryVariables = Exact<{[key: string]: never}>;

export type MeQuery = {
  me?: {
    __typename?: 'Driver';
    id: string;
    firstName?: string | null;
    lastName?: string | null;
    phone: string;
    smsOptInStatus?: DmDriverOptInStatus | null;
  } | null;
};

export type RemoveAssignmentsMutationVariables = Exact<{
  input: RemoveAssignmentsInput;
}>;

export type RemoveAssignmentsMutation = {
  removeAssignments?: {
    __typename?: 'RemoveAssignmentsPayload';
    deliveryId?: string | null;
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type RequestAccountCreateMutationVariables = Exact<{
  input: RequestAccountCreateInput;
}>;

export type RequestAccountCreateMutation = {
  requestAccountCreate?: {
    __typename?: 'RequestAccountCreatePayload';
    phone?: string | null;
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type MagicLinkRequestMutationVariables = Exact<{
  input: MagicLinkRequestInput;
}>;

export type MagicLinkRequestMutation = {
  magicLinkRequest?: {
    __typename?: 'MagicLinkRequestPayload';
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};

export type SelfAssignDriverMutationVariables = Exact<{
  input: SelfAssignDriverInput;
}>;

export type SelfAssignDriverMutation = {
  selfAssignDriver?: {
    __typename?: 'SelfAssignDriverPayload';
    driverAssignmentId?: string | null;
    userErrors: Array<{__typename?: 'ValidationError'; message: string}>;
  } | null;
};
